import React from "react";
import { useDispatch } from "react-redux";
import DTMAIAgent from "./DTMAIAgent";
import classes from "./LeftSidebar.module.css";
import { selectionsSliceActions } from "../store/slices/selectionsSlice";

const LeftSidebar = () => {
    const dispatch = useDispatch();
    const closeAgent = () => {
        dispatch(selectionsSliceActions.setAIagent(false));
        // Reset the timeline back to the default year when closing the agent.
        dispatch(selectionsSliceActions.setYear(2026));
    };

    return (
        <div className={classes.sidebar}>
            <DTMAIAgent onClose={closeAgent} />
        </div>
    );
};

export default LeftSidebar;
